import { Feature, Grid, ProductBlock } from '@/molecules';

import { generatedBeneficiosStyle } from '@/lib/contexts/beneficios-style.generated';

import type { FunctionComponent } from 'react';
import type { TypeBenefitsProps } from './types';

// Preset elegido por el tenant en ThemeConfiguration (`beneficiosStyle`):
//   `legacy` — features planos (histórico, cabecera centrada en desktop).
//   `card`   — Figma HoM (tarjetas blancas, texto centrado, cabecera izq.).
const isCard = generatedBeneficiosStyle === 'card';

export const Benefits: FunctionComponent<TypeBenefitsProps> = ({
  className = '',
  eyebrow,
  title,
  description,
  benefits,
  eyebrowStyleClass,
  titleStyleClass,
  descriptionStyleClass,
}: TypeBenefitsProps) => (
  <ProductBlock
    eyebrow={eyebrow}
    title={title}
    description={description}
    className={className}
    eyebrowStyleClass={eyebrowStyleClass}
    titleStyleClass={titleStyleClass}
    descriptionStyleClass={descriptionStyleClass}
    align={isCard ? 'left' : 'center'}
  >
    <Grid xxs={1} sm={2} lg={4} className={isCard ? 'gap-5' : 'gap-6'}>
      {benefits.map((feature, index: number) => (
        <Grid.Item key={index}>
          <Feature
            Icon={feature.Icon}
            image={feature.image}
            title={feature.title}
            variant={isCard ? 'card' : 'default'}
          >
            {feature.description}
          </Feature>
        </Grid.Item>
      ))}
    </Grid>
  </ProductBlock>
);

Benefits.displayName = 'Benefits';
